/* @flow */

export { openBridge, linkUrl, isBridge, needsBridge, needsBridgeForBrowser, hasBridge,
    needsBridgeForWin, needsBridgeForDomain, openTunnelToOpener, destroyBridges } from './index';



// WEBPACK FOOTER //
// ./node_modules/post-robot/src/bridge/interface.js